<template>
	<section class="logos-list-section text-color-white text-align-center py-200 px-50" :style="sectionBackgroundStyle">
		<div class="container">
			<div
				class="logo-group display-flex flex-wrap-wrap justify-content-center align-items-center gap-150 gap-300-md"
			>
				<h3 v-if="heading" class="label-sm text-transform-uppercase">{{ heading }}</h3>
				<div v-if="logos" class="logo-group-list col-12-smo col-8-md">
					<div
						:class="[
							'marquee-track',
							{ 'marquee--grayscale': props.grayscale },
							{ 'marquee--opaque': props.opaque }
						]"
						:style="`--marquee-logos-size: ${props.marqueeLogosSize}; --marquee-duration: ${props.marqueeDuration}; --marquee-gap: ${props.marqueeGap};`"
					>
						<ul class="marquee-list">
							<li v-for="(logo, l) in props.logos" :key="l">
								<BaseSvgIcon v-if="props.showSvgLogos" :name="logo" :title="logo" class="logo-img" />
								<img v-else :src="logo" alt="logo" class="logo-img" />
							</li>
						</ul>
						<ul :class="`marquee-list marquee--mirror`" aria-hidden="true">
							<li v-for="(logo, l) in props.logos" :key="l">
								<BaseSvgIcon v-if="props.showSvgLogos" :name="logo" :title="logo" class="logo-img" />
								<img v-else :src="logo" alt="logo" class="logo-img" />
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
	backgroundColor?: string;
	heading?: string;
	logos: Array<string>;
	showSvgLogos?: boolean; // pass BaseSvg names instead of image urls
	marqueeDuration?: string;
	marqueeGap?: string;
	marqueeLogosSize?: string;
	grayscale?: boolean;
	opaque?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	backgroundColor: '#151513',
	heading: undefined,
	showSvgLogos: false,
	marqueeDuration: '30s',
	marqueeGap: '1rem',
	marqueeLogosSize: '3rem',
	grayscale: false,
	opaque: false
});

const sectionBackgroundStyle = computed((): string => {
	return props.backgroundColor ? `background-color: ${props.backgroundColor}` : '';
});
</script>

<style scoped lang="scss">
@use '../../styles/utilities/respond-to.scss' as *;

.logos-list-section {
	.logo-group-list {
		@include respond-to(lg) {
			.marquee-list {
				animation: none;
			}
		}
	}
}

.venture-logos-list {
	@include respond-to(lg) {
		padding-top: 0;
	}
}
</style>
